import type { components } from "@cntrl/api-client";

/** One sentence for what a DSP link sync came to (ART-219) — shared by the Smart Link section's "Sync DSP Links"
 *  and the automatic follow-up after a track sync, so the two can never word one result differently. */
export function dspSyncMessage(
  r: components["schemas"]["DspLinkSyncResult"],
): [string, "success" | "info" | "warning" | "error"] {
  switch (r.status) {
    case "found": {
      const filled = r.filled ?? 0;
      const pending = r.pending ?? 0;
      if (filled > 0) return [`Found ${filled} DSP ${filled === 1 ? "link" : "links"}.`, "success"];
      if (pending > 0) return ["Found links that need a pick. Use Resolve links.", "info"];
      return ["DSP links are up to date.", "info"];
    }
    case "none-found":
      return ["No DSP links found yet. Try again later.", "info"];
    case "no-track":
      return ["This release has no tracks from Spotify yet.", "warning"];
    case "no-artist":
      return ["Connect the band's Spotify artist first.", "warning"];
    case "not-configured":
      return ["DSP link lookup isn't set up on this server.", "warning"];
    default:
      return ["Couldn't fetch DSP links. Try again in a minute.", "error"];
  }
}
